@if (assumeSession.isAssuming()) {
  <div
    class="assume-banner d-flex align-items-center gap-2 px-2 py-1 rounded"
    [class.expired]="assumeSession.isExpired()"
  >
    <fa-icon [icon]="icons.secret"></fa-icon>
    <span class="label">
      @if (assumeSession.isExpired()) {
        Session expired
      } @else {
        Assuming <strong>{{ assumeSession.targetLabel() }}</strong>
      }
    </span>
    <button
      type="button"
      class="btn btn-sm btn-outline-dark ms-1"
      (click)="end()"
      title="Return to your account"
    >
      <fa-icon [icon]="icons.exit"></fa-icon>
    </button>
  </div>

  @if (assumeSession.warningActive()) {
    <div class="assume-warning-backdrop">
      <div class="assume-warning-card shadow-lg">
        <h5 class="mb-2">Are you still there?</h5>
        <p class="text-muted mb-3">
          You'll be returned to your account in
          <strong>{{ assumeSession.warningSecondsLeft() }}s</strong>
          due to inactivity.
        </p>
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-primary" (click)="stay()">
            Stay signed in
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="end()">
            Return now
          </button>
        </div>
      </div>
    </div>
  }
}
